"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TransformYourAtmosphere() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="226043" id="the-gateway-to-asia" className="relative min-h-screen flex items-center bg-background text-foreground overflow-hidden py-20 lg:py-0">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/subtle_noise_texture.png)] opacity-5 pointer-events-none mix-blend-multiply" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 flex flex-col lg:flex-row items-center justify-center w-full max-w-7xl">
        
        {}
        <div ref={imageRef} className={`w-full lg:w-3/5 relative h-[60vh] lg:h-[80vh] rounded-2xl overflow-hidden shadow-2xl transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/light-and-sound-show-in-hong-kong-2026-03-17-19-46-26-utc-scaled.png" alt="Luxury yacht in Victoria Harbour, Hong Kong" className="w-full h-full object-cover" src="https://offsiteasia.com/wp-content/uploads/2026/05/20190604_120313-scaled-1.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/light-and-sound-show-in-hong-kong-2026-03-17-19-46-26-utc-scaled.png" src="https://offsiteasia.com/wp-content/uploads/2026/05/20190525_202512-scaled.jpg" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/light-and-sound-show-in-hong-kong-2026-03-17-19-46-26-utc-scaled.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/light-and-sound-show-in-hong-kong-2026-03-17-19-46-26-utc-scaled.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/light-and-sound-show-in-hong-kong-2026-03-17-19-46-26-utc-scaled.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/light-and-sound-show-in-hong-kong-2026-03-17-19-46-26-utc-scaled.png" src="https://offsiteasia.com/wp-content/uploads/2026/05/IMG_20190208_104346-scaled.jpg" />
          {}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-primary/10 pointer-events-none" />
        </div>

        {}
        <div ref={cardRef} className={`w-full lg:w-2/5 lg:-ml-16 mt-[-4rem] lg:mt-0 relative z-20 transition-all duration-1000 delay-300 ease-out ${isCardVisible ? "opacity-100 translate-y-0 lg:translate-x-0" : "opacity-0 translate-y-8 lg:translate-y-0 lg:translate-x-8"}`}>
          <Card className="bg-card/95 backdrop-blur-sm border-none shadow-3xl rounded-2xl overflow-hidden">
            <CardContent className="p-8 sm:p-12 lg:p-14 flex flex-col gap-6 lg:gap-8">
              <h1 className="font-default text-5xl sm:text-6xl lg:text-7xl leading-[1.1] text-primary tracking-tight">Tell us who's coming.<div>We handle everything else.&nbsp;</div></h1>
              
              <p className="font-default text-lg text-muted-foreground leading-relaxed">Corporate experiences, incentive travel, and team programmes in Hong Kong - fully managed, zero friction. One brief. One contact. One invoice.</p>
              
              <div className="pt-2 flex flex-col sm:flex-row gap-4">
                <Button asChild size="lg" className="h-14 px-8 text-base rounded-md bg-chart-3 hover:bg-chart-3/90 text-accent-foreground shadow-md hover:shadow-lg transition-all w-full sm:w-auto">
                  
                </Button>
                <Button asChild size="lg" className="h-14 px-8 text-base rounded-md bg-chart-3 hover:bg-chart-3/90 text-accent-foreground shadow-md hover:shadow-lg transition-all w-full sm:w-auto">
                  <Link to="/ServicesPage">See What We Do</Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>

      </div>
    </section>;
}